import { Routes as CoreRoutes } from 'core/pages'
import BrowserPrintEncode from './Encoding/BrowserPrint/BrowserPrintEncode'
import EncodingVerify from './Encoding/EncodingVerify'
import ShippingReading from './Shipping/ShippingReading'
import ShippingStart from './Shipping/ShippingStart'
import WithEncodingReading from './Shipping/WithEncoding/WithEncodingReading'
import SimpleItemListReading from './SimpleItemList/SimpleItemListReading'
import SimpleReadingListStart from './SimpleReadingList/SimpleReadingListStart'
import OneIDTable from './SimpleReadingList/OneIDTable/OneIDTable'

///////////////////////////////////////////////////////////////////////////////
// Custom & core overrides, change only this!
///////////////////////////////////////////////////////////////////////////////

/*
const CustomRoutes = {
  '/simple-item-list/:opCode/reading': { component: SimpleItemListReading },
  '/simple-parcel-list/:opCode': { component: SimpleParcelListStart },
}
*/

const CustomDirectRoutes = {
  '/oneIDTable': { component: OneIDTable }
}

const CustomRoutes = {
  '/shipping/:opCode': { component: ShippingStart },
  '/shipping/:opCode/reading': { component: ShippingReading },
  '/encoding/:opCode/verify': { component: EncodingVerify },
  '/encoding/browserPrint/:opCode': { component: BrowserPrintEncode },
  '/shipping/withEncoding/:opCode': { component: WithEncodingReading },
  '/simple-item-list/:opCode/reading': { component: SimpleItemListReading },
  '/simple-reading-list/:opCode': { component: SimpleReadingListStart }
}

///////////////////////////////////////////////////////////////////////////////

export const Routes = { ...CustomDirectRoutes, ...CoreRoutes, ...CustomRoutes }
// eslint-disable-next-line
export type Routes = keyof typeof Routes
